(function () {
  "use strict";

  function instagramEmbedUrl(url) {
    var clean = String(url || "").split("?")[0].replace(/\/$/, "");
    return clean ? clean + "/embed" : "";
  }

  function getVideoSource(button) {
    var platform = button.getAttribute("data-video-platform");
    if (platform === "youtube") {
      var id = button.getAttribute("data-video-id");
      if (!id) return "";
      return "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?autoplay=1&rel=0&playsinline=1";
    }
    if (platform === "instagram") {
      return instagramEmbedUrl(button.getAttribute("data-video-url"));
    }
    return "";
  }

  function initialize(root) {
    if (!root || root.dataset.zvCreatorReady === "true") return;
    root.dataset.zvCreatorReady = "true";

    var tabs = root.querySelectorAll("[data-zv-creator-tab]");
    var panels = root.querySelectorAll("[data-zv-creator-panel]");
    var modal = root.querySelector("[data-zv-video-modal]");
    var frame = root.querySelector("[data-zv-video-frame]");
    var previousFocus = null;

    function activateTab(tab) {
      var platform = tab.getAttribute("data-zv-creator-tab");
      tabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle("is-active", active);
        item.setAttribute("aria-selected", active ? "true" : "false");
      });
      panels.forEach(function (panel) {
        panel.classList.toggle("is-active", panel.getAttribute("data-zv-creator-panel") === platform);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activateTab(tab);
      });
    });

    panels.forEach(function (panel) {
      var track = panel.querySelector("[data-zv-creator-track]");
      var previous = panel.querySelector("[data-zv-creator-prev]");
      var next = panel.querySelector("[data-zv-creator-next]");
      if (!track) return;

      function amount() {
        var card = track.querySelector(".zv-creator-card");
        return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.82;
      }

      if (previous) {
        previous.addEventListener("click", function () {
          track.scrollBy({ left: -amount(), behavior: "smooth" });
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          track.scrollBy({ left: amount(), behavior: "smooth" });
        });
      }
    });

    function openModal(button) {
      if (!modal || !frame || !button) return;
      var source = getVideoSource(button);
      if (!source) return;

      var platform = button.getAttribute("data-video-platform");
      previousFocus = button;

      modal.classList.toggle("is-instagram", platform === "instagram");
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("zv-video-modal-open");

      frame.innerHTML = '<iframe src="' + source + '" title="Creator video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';

      /* Detach from any transformed/sticky Shopify container so position:fixed is truly viewport-fixed. */
      if (modal.parentNode !== document.body) document.body.appendChild(modal);

      var closeButton = modal.querySelector(".zv-video-modal__close");
      if (closeButton) window.setTimeout(function () { closeButton.focus({ preventScroll: true }); }, 0);
    }

    function closeModal() {
      if (!modal || !frame || !modal.classList.contains("is-open")) return;
      modal.classList.remove("is-open", "is-instagram");
      modal.setAttribute("aria-hidden", "true");
      frame.innerHTML = "";
      document.body.classList.remove("zv-video-modal-open");
      if (previousFocus && typeof previousFocus.focus === "function") {
        previousFocus.focus({ preventScroll: true });
      }
      previousFocus = null;
    }

    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-zv-video-open]");
      if (button && root.contains(button)) {
        event.preventDefault();
        openModal(button);
      }
    });

    if (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target.closest("[data-zv-video-close]")) closeModal();
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal && modal.classList.contains("is-open")) closeModal();
    });
  }

  function initializeAll(container) {
    (container || document).querySelectorAll("[data-zv-creator-videos]").forEach(initialize);
  }

  function boot() {
    initializeAll(document);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", function (event) {
    initializeAll(event.target);
  });
})();
